<div class="ui-card">
  <ng-content></ng-content>
</div>
